import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { formatTime } from 'modules/core/lib/formatTime'

export const useTimeFormatted = () => {
  const { access } = useCurrentSession()

  return (time: string): string => {
    const formattedTime = formatTime(access, time)
    return formattedTime || ''
  }
}
